import React from "react";
import css from "./index.css";
import cs from 'classnames';

const config = {
  "needL1" : {
    css: 'notverify',
    title: '',
    desc: 'Please verify your phone number & email before uploading your documents.'
  },
  "pending": {
    css: 'pending',
    title: 'Approve Status : Pending',
    desc: 'Verification submitted successful, your current status is pending. Once your documents are verified, you will receive an email notification. If you don’t receive any feedback within 24 hours (Mon-Fri), please contact us.'
  },
  "notverify": {
    css: 'notverify',
    title: 'DOT/MC Number Not Verified',
    desc: 'Please go to account Information page to verify your DOT/MC number first, so you can start our carrier verification.'
  },
  "success": {
    css: 'success',
    title: 'Verification Approved',
    desc: 'Congratulation, now you have booking access to our loads!'
  },
  "onboarding": {
    css:'pending',
    title: 'Approve Status : Pending',
    desc: 'Your documents are being reviewed by Loadsmart, you will be notified once approved.'
  }
}

export default class Status extends React.Component {
  constructor(props){
    super(props)
  }
  render() {
    const { type } = this.props;
    const { css:cssName, title, desc } = config[type];
    return (
      <div className={css.statusWarp}>
        <div className={cs(css.icon, css["icon-"+ cssName])}></div>
        <div className={css.title}>{title}</div>
        <div className={css.desc}>{desc}</div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/MyAccount/BidVerfiy/component/status/index.js